import script from "./navbarMenue.vue?vue&type=script&setup=true&lang=js"
export * from "./navbarMenue.vue?vue&type=script&setup=true&lang=js"

import "./navbarMenue.vue?vue&type=style&index=0&id=96faa4a8&lang=css"

const __exports__ = script;

export default __exports__